import FormattedMessage from 'I18n/components/FormattedMessage';
import { ONBOARDING_MARKETING_FREE, ONBOARDING_STARTER_MARKETING, ONBOARDING_INVITED_MARKETING } from 'getting-started-shared-tasks/onboardingKeys';
import { MARKETING_ACADEMY_URL, CONTACTS_TOUR_URL, FREE_APP_MARKETPLACE_URL, MARKETING_STARTER_APP_MARKETPLACE_URL } from '../constants/urls';
import { LEARN_MORE_CTAS } from '../constants/enums';
import { getDefaultMarketingTaskGroupOverrides } from '../constants/defaultTaskGroupOverrides';
import { jsx as _jsx } from "react/jsx-runtime";
export default function getMarketingViewConfig(__appContexts) {
  return {
    [ONBOARDING_MARKETING_FREE]: {
      taskGroupOverrides: getDefaultMarketingTaskGroupOverrides(),
      learnMore: {
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketing.learnMore.description"
        }),
        ctas: [{
          ctaId: LEARN_MORE_CTAS.ACADEMY_MARKETING,
          href: MARKETING_ACADEMY_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketing.learnMore.ctas.academy-marketing"
          }),
          icon: 'cap'
        }, {
          ctaId: LEARN_MORE_CTAS.CONTACTS_TOUR_MARKETING,
          href: CONTACTS_TOUR_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketing.learnMore.ctas.contacts-tour"
          }),
          icon: 'contactDuplicate'
        }, {
          ctaId: LEARN_MORE_CTAS.MARKETPLACE_MARKETING,
          href: FREE_APP_MARKETPLACE_URL,
          external: true,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketing.learnMore.ctas.app-marketplace-marketing"
          }),
          icon: 'marketplace'
        }]
      }
    },
    [ONBOARDING_INVITED_MARKETING]: {
      taskGroupOverrides: getDefaultMarketingTaskGroupOverrides(),
      learnMore: {
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketing.learnMore.description"
        }),
        ctas: [{
          ctaId: LEARN_MORE_CTAS.ACADEMY_MARKETING,
          href: MARKETING_ACADEMY_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketing.learnMore.ctas.academy-marketing"
          }),
          icon: 'cap'
        }, {
          ctaId: LEARN_MORE_CTAS.CONTACTS_TOUR_MARKETING,
          href: CONTACTS_TOUR_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketing.learnMore.ctas.contacts-tour"
          }),
          icon: 'contactDuplicate'
        }, {
          ctaId: LEARN_MORE_CTAS.MARKETPLACE_MARKETING,
          href: FREE_APP_MARKETPLACE_URL,
          external: true,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketing.learnMore.ctas.app-marketplace-marketing"
          }),
          icon: 'marketplace'
        }]
      }
    },
    [ONBOARDING_STARTER_MARKETING]: {
      taskGroupOverrides: getDefaultMarketingTaskGroupOverrides(),
      learnMore: {
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketing.learnMore.description"
        }),
        ctas: [{
          ctaId: LEARN_MORE_CTAS.ACADEMY_MARKETING,
          href: MARKETING_ACADEMY_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketing.learnMore.ctas.academy-marketing"
          }),
          icon: 'cap'
        }, {
          ctaId: LEARN_MORE_CTAS.CONTACTS_TOUR_MARKETING,
          href: CONTACTS_TOUR_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketing.learnMore.ctas.contacts-tour"
          }),
          icon: 'contactDuplicate'
        }, {
          ctaId: LEARN_MORE_CTAS.MARKETPLACE_MARKETING,
          href: MARKETING_STARTER_APP_MARKETPLACE_URL,
          external: true,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketing.learnMore.ctas.app-marketplace-marketing"
          }),
          icon: 'marketplace'
        }]
      }
    }
  };
}